module.exports = __webpack_public_path__ + "media/images/logo-shield-3417e7260df5148c67821ce85d757645.svg";